export default __webpack_public_path__ + "static/media/etapa2.c89d4c28.png";